export default "__VITE_ASSET__sO8o4Xyx__"